// Page404 Componenet

import React, { Component } from 'react'

import app from '../../../app.jsx'
import Button from '../../common/button/button.jsx'
import IntlMessage from '../../common/intl/intl_message.jsx'

class Page404 extends Component {
  render () {
    return (
      <div className='page-404'>
        <div className='container'>
          <div className='inner'>
            <div className='typo'>
              <h1 className='title'>
                <IntlMessage ident='common.404.title' />
              </h1>
              <div className='content'>
                <p>
                  <IntlMessage ident='common.404.info' />
                  <a className='link' href='https://support.getrodeo.io'>
                    <IntlMessage ident='common.404.titleRodeo' />
                  </a>
                  .
                </p>
              </div>
              <Button
                className='button_404'
                title='common.404.buttonTitle'
                icon='common-warning'
                canHover={false}
                onClick={this._onClick.bind(this)}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }

  /* Event Handler */
  _onClick (ev) {
    ev.preventDefault()
    ev.stopPropagation()
    if (app.loggedInId) {
      app.redirect('/')
    } else {
      app.redirect('/login')
    }
  }
}

export default Page404
